import { IntlShape } from "react-intl";

import { Nullable } from "@mapmycustomers/shared";
import CountryCode from "@mapmycustomers/shared/enum/CountryCode";
import Address from "@mapmycustomers/shared/types/Address";
import Located, { GeoManagementState } from "@mapmycustomers/shared/types/base/Located";
import GeoAddress from "@mapmycustomers/shared/types/GeoAddress";
import { convertLongLatToGeoPoint } from "@mapmycustomers/shared/util/geo/GeoService";

import formatCountryName from "@app/util/countries/formatCountryName";
import geoAddressToNullableAddress from "@app/util/geoAddressToNullableAddress";

export const getAddress = (
  formData: any,
  originalEntity: Located,
  intl: IntlShape
): Partial<Nullable<Address> & Pick<Located, "geoAddress" | "geoManagementState" | "geoPoint">> => {
  const lat = parseFloat(formData.latitude);
  const lon = parseFloat(formData.longitude);
  const geoPointsChanged =
    !isNaN(lat) &&
    !isNaN(lon) &&
    (originalEntity.geoPoint?.coordinates[1] !== lat ||
      originalEntity.geoPoint?.coordinates[0] !== lon);

  const addressDetails: GeoAddress = formData.addressDetails;
  const wasAddressChanged =
    addressDetails.address !== originalEntity.address ||
    addressDetails.countryCode !== originalEntity.countryCode ||
    addressDetails.city !== originalEntity.city ||
    addressDetails.region !== originalEntity.region ||
    addressDetails.regionCode !== originalEntity.regionCode ||
    addressDetails.postalCode !== originalEntity.postalCode;

  const address = addressDetails
    ? {
        ...geoAddressToNullableAddress(addressDetails, wasAddressChanged),
        // simplify it in scope of TART-19157 after TART-22395, TART-22396
        country: addressDetails.countryCode
          ? formatCountryName(intl, addressDetails.countryCode as CountryCode)
          : addressDetails.countryCode === null
          ? null
          : undefined,
        geoAddress: addressDetails,
        // send AUTOMATIC_PRESERVE_ADDRESS when coordinates and address has changed and send MANUAL when only coordinates has changed
        geoManagementState: geoPointsChanged
          ? GeoManagementState.MANUAL
          : wasAddressChanged
          ? GeoManagementState.AUTOMATIC_PRESERVE_ADDRESS
          : originalEntity.geoManagementState,
        // preserve geoPoint if address was not changed
        geoPoint: geoPointsChanged
          ? convertLongLatToGeoPoint([lon, lat])
          : wasAddressChanged || isNaN(lat) || isNaN(lon)
          ? null
          : originalEntity.geoPoint,
      }
    : {};

  return address;
};
